module.exports = "https://cdn.realtymogul.com/static/media/StressUncertaintyPanel.3e0bb96e.png";